import React, { Component } from 'react';
import { useGetItemCountForGuideline } from '../../hooks/useGuideline';
import { LoadingOutlined, StopOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import CountUp from 'react-countup';
const formatter = value => <CountUp end={value} separator="," duration={1} />;

export default function LinkCount({ link }) {
    const { data, isFetched, isFetching, isError } = useGetItemCountForGuideline(link);

    const StatusView = ({ status }) => {
        return (
            <>
                {!!status && (
                    <div>
                        <table>
                            <tr>
                                <td>Pending </td>
                                <td>{status?.Pending || 0}</td>
                            </tr>
                            <tr>
                                <td>Partial </td>
                                <td>{status?.Partial || 0}</td>
                            </tr>
                            <tr>
                                <td>Complete </td>
                                <td>{status?.Complete || 0}</td>
                            </tr>
                        </table>
                    </div>
                )}
            </>
        );
    };

    return (
        <>
            <div
                style={{
                    margin: '0 5px',
                    padding: '0 5px',
                    backgroundColor: 'pink',
                    border: '1px dashed black',
                    boxShadow: '1px 1px 2px #777',
                    textAlign: 'center',
                }}
            >
                {!!isFetching && <LoadingOutlined />}
                {!!isError && <StopOutlined />}
                {!!isFetched && !isError && !isFetching && (
                    <CountUp start={0} end={data?.total || 0} delay={0} duration={1}>
                        {({ countUpRef }) => (
                            <div>
                                <Tooltip title={<StatusView status={data?.status} />}>
                                    <span ref={countUpRef} />
                                </Tooltip>
                            </div>
                        )}
                    </CountUp>
                )}
            </div>
        </>
    );
}
